import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const inviteStudentList = createAsyncThunk('inviteStudentList', async ({ pageable: data, navigate, allBranches }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `invite_student_list`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                ...(allBranches ? { all_branches: true } : {}),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const inviteStudentListSlice = createSlice({
    name: 'inviteStudentList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(inviteStudentList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = (() => { const raw = action.payload.data.data; return Array.isArray(raw) ? raw : (Object.values(raw || {}).find(Array.isArray) || []); })();
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(inviteStudentList.rejected, (state, action) => { // console.log('reject', action)
        })
    }
})

export default inviteStudentListSlice.reducer;
